var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52.2523,
    height: 52.2523,
    rx: 26.1261,
    fill: "#D4EAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1262 16.126H29.1262C27.8001 16.126 26.5284 16.6528 25.5907 17.5904C24.653 18.5281 24.1262 19.7999 24.1262 21.126V24.126H21.1262V28.126H24.1262V36.126H28.1262V28.126H31.1262L32.1262 24.126H28.1262V21.126C28.1262 20.8608 28.2316 20.6064 28.4191 20.4189C28.6067 20.2313 28.861 20.126 29.1262 20.126H32.1262V16.126Z",
    stroke: "#0071DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.6ee0d039b3bc8dc3f3fe79f26fdfa15c.svg";
export { ForwardRef as ReactComponent };